<!-- svelte-ignore css-unused-selector -->
<script lang="ts">
    import {createEventDispatcher, onDestroy} from "svelte";
    import {StoredApplicationData, IncidentalError} from "../services/Store";
    import {ApplicationData} from "../models/ApplicationData";
    import {identificationCompleted, identificationSkipped} from "../services/NavigationService";
    import {uploadFile} from "../services/ApplicationDataService";

    let complete = false;
    let applicationId = '';
    let applicationData = new ApplicationData();
    let files;
    let fileVar;
    let postVar;
    let buttonText = 'Continue To Next Step';
    let continueToNextStep = false;
    const dispatch = createEventDispatcher();
    const applicationDataUnsubscribe = StoredApplicationData.subscribe(value => applicationData = value);
    let imageUrl = process.env.ImagesUrl + 'images/PurpleCheck.png';

    onDestroy(applicationDataUnsubscribe)

    const fileSelect = (e) => {
        if (e.target.files.length > 0 && !complete) {
            complete = true;
            const fileNameSpan = document.getElementById('selectedFileName');
            if (fileNameSpan) {
                fileNameSpan.innerText =  e.target.files[0].name;
            }

            dispatch("identificationImageUploaded")
        }
    }

    const fileUploadCompleted = (e) => {
        e.preventDefault();
        window.scrollTo(0,0);
        identificationCompleted();
    }

  function upload(event: any) {
        if (event) {
            event.preventDefault();
        }
      window.scrollTo(0,0);
        if (fileVar && fileVar.length > 0) {
            const formData = new FormData();
            formData.append('fileData', fileVar[0]);
            formData.append('applicationId', applicationData.applicationId);
            uploadFile(formData);
            if (!$IncidentalError)
            {
                identificationCompleted();
            }
        }
       else {

            identificationSkipped(applicationData);
        }
    }

</script>

<div class="card-no-border">
    {#if complete}<img src= {imageUrl} alt="Completed"  />{/if}
    <h1>Upload My Identification Card (Optional)</h1>
    <hr />
    <div>
        Please note, this is an OPTIONAL selection.  If you do not wish to provide a copy of your ID at this time please click the 'Continue to next step' button below.
    </div>
    <p>
        *If you would like to upload from your desktop, please click the ‘Choose File’ button below and select the image from your computer. Once selected, click the 'Continue to next step' and your image will be saved.
    </p>



</div>

<div class="identification-card card">

<div class="text-section">
    <div class="control-row">
        <div class="control-group-horizontal">
          <form on:submit={upload}>
                    <input type="hidden" bind:value={postVar} placeholder={"Testing"} />

                     <label class="file">
                     <input type="file" id="file" bind:files={fileVar}  style="border:none; font-size: 16px;" >

                   </label>

                    <br /><br/>

                  <button class="pl-cta-primary" type="submit"  on:click={upload}>{buttonText}</button>




                </form>
        </div>
        </div>
        </div>




</div>


<style lang="scss">
    @use "../../component_scss_library/layout" as layout;
    @use "../../component_scss_library/buttons" as buttons;
     @use "../../component_scss_library/forms" as forms;
</style>
